<template>
    <div class="container-scroller">

        <slot name="head"></slot>
        <!-- partial:partials/_navbar.html -->
        <HeaderNav/>
        <!-- partial -->
        <div class="container-fluid page-body-wrapper">

            <!-- partial:partials/_sidebar.html -->
            <slot name="body"></slot>
            <div class="settings-trigger" @click="show">
                <p v-if="!showBox">Click here to test bot replies</p>
                <div id="settings-trigger">
                    <i v-if="!showBox" class="mdi mdi-message"></i>
                    <i v-if="showBox" class="mdi mdi-close"></i>
                </div>
            </div>
            <div class="chatbox-panel" v-if="showBox">
                <div class="header">
                    <div class="text-light">Bot</div>
                </div>
                <div class="chatbox-messages">

                    <Loader v-if="isLoading" ></Loader>
                    <p v-if="error&& !isLoading" style="margin-top: 70px;padding: 5px 10px">No intent found for the phrase, please refine and try again</p>
                    <section v-if="!error && !isLoading && responses.length>0" class="discussion">
                        <div class="intent__name">
                            <span class="dsr">Intent Name</span>
                            <span class="text-bold">{{name}}</span>
                        </div>
                        <div class="intent__type">
                            <span class="dsr">Response Type</span>
                            <span class="text-bold">{{getIntentType}}</span>
                        </div>
                        <div class="intent__response">
                            <span class="dsr">Response</span>
                            <span class="">{{getIntentText}}</span>
                        </div>



                    </section>
                </div>
                <div class="chatbox-input">
                    <textarea v-model="message" rows="2" type="text" placeholder="Type your message here..."
                              autofocus></textarea>
                    <div v-bind:class="{disabled:isLoading}" @click="sendMessage" class="bsend"><i
                            class="mdi mdi-send"></i></div>
                </div>
            </div>


        </div>
        <!-- page-body-wrapper ends -->
    </div>
    <!-- container-scroller -->
</template>

<script>
    import HeaderNav from './HeaderNav';
    import Loader from './Loader/Loader';
    import {userService} from '../services/user.service';

    export default {
        name: "Layout",
        components: {HeaderNav,Loader},
        data() {
            return {
                showBox: false,
                message: "",
                isLoading: false,
                responses: [],
                error:false,
                name: ""
            }
        },
        computed: {
            getIntentType() {
                return this.responses[0] ? this.responses[0].type : "";
            },
            getIntentText() {
                return this.responses[0] ? this.responses[0].text : "";
            }
        },
        async mounted() {


            // Verify the User token is still valid
            // let loginValid = await this.$store.dispatch('AUTHORISE_USER', this.$store.getters.GET_AUTH_TOKEN);
            //
            // // If login is not valid

        }, methods: {
            show() {
                this.showBox = !this.showBox;
            },
            async sendMessage() {
                if (this.message.length < 1) return
                this.isLoading = true;
                this.error= false;
                await userService.getUtterance(this.message)
                    .then((res) => {

                        console.log(res)
                        if (res.json !== null) {
                            this.name = res.name;
                            res.json.map((res, index) => {
                                return this.responses = res.document;
                            });
                        }
                        else {
                            this.error=true;
                        }
                        console.log(this.responses);
                        this.message = "";
                        // this.dashboardData = res;
                        //this.groupList = res;
                        //console.log(this.groups);
                        this.isLoading = false
                    }).catch((error) => {
                        this.error=true;
                        this.isLoading = false;
                        this.$toastr.error(error.message, "Error parsing utterance!", {timeOut: 3000});

                    });
            }
        }
    }
</script>

<style scoped>
    .intent__name,.intent__response,.intent__type{
        margin-bottom: 10px;
    }
    .intent__name .dsr, .intent__type .dsr, .intent__response .dsr{
        background: #049737;
        font-size: .8em;
        padding: 3px 4px;
        color: white;
        border-radius: 3px;
        margin-right: 5px;
    }
    .intent__type .dsr{
        background: #393a97;
    }
    .intent__response .dsr{
        background: red;
    }
.text-bold{
    font-weight: bold;
}
    .disabled {
        pointer-events: none;
        opacity: .6;
    }

    .settings-trigger {
        position: fixed;
        bottom: 40px;
        right: 30px;
        padding: 16px 15px;
        color: black;
        flex-direction: column;
        cursor: grab;

        z-index: 99;
    }

    #settings-trigger {
        height: 45px;
        background: #353cd6;
        margin-left: auto;
        color: white;
        width: 45px;
        -webkit-box-shadow: 0px 0px 31px 6px rgba(0, 0, 0, 0.17);
        box-shadow: 0px 0px 31px 6px rgba(0, 0, 0, 0.17);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        border-radius: 100%;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .chatbox-panel {
        background: white;
        border-radius: 15px;
        transition: all 1s ease-in-out;
        position: absolute;
        right: 20px;
        width: 320px;
        bottom: 100px;
        height: 350px;
    }

    .chatbox-panel .chatbox-messages {
        height: 75%;
        overflow-y: scroll;
        position: relative;
        border-bottom: 1px solid grey;
    }

    .chatbox-messages .messages {
        padding: 10px 18px;
    }

    .chatbox-panel .chatbox-input {
        height: 25%;
        padding: 10px 15px;
        display: flex;
        justify-content: space-around;
    }

    .chatbox-panel .header {
        background: #353cd6;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 10;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        box-sizing: border-box;

        padding: 10px 12px;
    }

    .chatbox-messages .discussions {
        position: relative;
        width: 98%;
        z-index: 5;
        height: 98%;

        overflow: hidden;
        overflow-y: scroll;
    }

    textarea {
        box-sizing: border-box;
        width: 80%;
        margin: 0;
        /*height: calc(16px + 16px / 2);*/
        padding: 0 calc(16px / 2);
        font-family: inherit;
        font-size: 16px;
        color: #222222;
        background-color: none;
        border: 0;
        outline: 0 !important;
        resize: none;
        overflow: hidden;
    }

    textarea::-webkit-input-placeholder {
        color: #888;
    }

    textarea:-ms-input-placeholder {
        color: #888;
    }

    textarea::-ms-input-placeholder {
        color: #888;
    }

    textarea::placeholder {
        color: #888;
    }

    .bsend {
        width: 2.5em;
        height: 2.5em;
        color: white;
        text-align: center;
        background: #1acfb4;
        border-radius: 50%;
    }

    .bsend i {
        line-height: 2.5em;
        margin-left: 5px;
    }

    .discussion {
        width: 98%;
        padding: 2px 5px;
        margin: 0 auto;
        margin-top: 50px;
        margin-bottom: 10px;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        overflow-y: scroll;
        display: flex;
        flex-flow: column wrap;
    }

    .discussion > .bubble {
        border-radius: 1em;
        padding: 0.25em 0.75em;
        margin: 0.0625em;
        max-width: 80%;
    }

    .discussion > .bubble.sender {
        align-self: flex-start;
        background-color: cornflowerblue;
        color: #fff;
    }

    .discussion > .bubble.recipient {
        align-self: flex-end;
        background-color: #efefef;
    }

    .discussion > .bubble.sender.first {
        border-bottom-left-radius: 0.1em;
    }

    .discussion > .bubble.sender.last {
        border-top-left-radius: 0.1em;
    }

    .discussion > .bubble.sender.middle {
        border-bottom-left-radius: 0.1em;
        border-top-left-radius: 0.1em;
    }

    .discussion > .bubble.recipient.first {
        border-bottom-right-radius: 0.1em;
    }

    .discussion > .bubble.recipient.last {
        border-top-right-radius: 0.1em;
    }

    .discussion > .bubble.recipient.middle {
        border-bottom-right-radius: 0.1em;
        border-top-right-radius: 0.1em;
    }
</style>
